import React from 'react';

const CheckMark = () => (
	<svg width="11px" height="12px" viewBox="0 0 11 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
		<title>Green CheckMark</title>
		<desc>Created with Sketch.</desc>
		<g id="SEM" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="03-SEM-1" transform="translate(-406.000000, -1455.000000)" fill="#80CFC2">
				<g id="SECTION-1" transform="translate(61.000000, 900.000000)">
					<g id="text" transform="translate(0.000000, 84.000000)">
						<path d="M350.290353,481.268905 C348.698168,479.930779 347.307994,478.378225 346.169718,476.635797 C345.738072,475.975327 344.666995,476.589965 345.101939,477.255345 C346.464491,479.340694 348.156033,481.189518 350.134103,482.715472 C350.509681,483.005195 351.000282,482.913941 351.167251,482.444574 C352.374376,479.057519 353.966149,475.8231 355.901343,472.78715 C356.328042,472.117678 355.258203,471.500994 354.833153,472.167602 C353.003912,475.037411 351.488821,478.090139 350.290353,481.268905 Z" id="Fill-1"></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default CheckMark;
